import { CommonModule } from '@angular/common';
import { HttpClient, provideHttpClient } from '@angular/common/http';
import { Component, signal } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommunicateService } from '../core/services/communicate.service';
import { CommonApiService } from '../core/services/common-api.service';
import { AdminNotifyService } from '../core/services/admin-notify.service';
import { CoreModule } from '../core/core.module';
import { ToastrService } from 'ngx-toastr';
import { LoginRequest } from '../core/interfaces/common';
import { TranslateModule } from '@ngx-translate/core';
import { PERMANENT_FEATURE_DETAIL } from '../shared/constants/permanent-feature-detail.constants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InfoModalComponent } from '../core/modals/info-modal/info-modal.component';
import { environment } from '../../environments/environment';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, CoreModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {

  readonly isSuperAdmin = environment.isSuperAdmin;

  public loginForm: FormGroup;
  showPassword: boolean = false;
  isFieldValid = signal<boolean>(false);
  isMailValid = signal<boolean>(false);

  constructor(private fb: FormBuilder, private router: Router, private activeRoute: ActivatedRoute, private communicate: CommunicateService, private api: CommonApiService, private toastr: ToastrService,
    private modalService: NgbModal,
    private adminNotify: AdminNotifyService
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    })

  }
  ngOnInit() {

  }
  get field() { return this.loginForm.controls }

  onSubmit() {

    if (this.loginForm.invalid) {
      this.isFieldValid.set(true);
      return
    }
    this.communicate.isLoaderLoad.next(true);
    let payload: LoginRequest = {
      "email": this.loginForm.get('email')?.value,
      "password": this.loginForm.get('password')?.value
    }
    localStorage.clear();

    // this.api.allPostMethod('authentication/login', payload).subscribe({
    //   next: async (res: any) => {
    //     this.communicate.isLoaderLoad.next(false);
    //     if (res['error'] != true) {
    //       localStorage.setItem('sp-token', res['data']['token']);
    //       localStorage.setItem('userId', res['data']['userId']);
    //       localStorage.setItem('userName', res['data']['fullName']);
    //       localStorage.setItem('permission_data', JSON.stringify(res['data']['permissionData']));

    //       let obj = JSON.parse(JSON.stringify(res['data']));
    //       obj['permissionData'] = null;

    //       const subscriptionData: any = await this.getAllSubscriptionFeatures();
    //       const hasFormWizSubscription = Array.isArray(subscriptionData) && subscriptionData.some((s: any) =>
    //         Number((s?.permanentFeatureCode) === PERMANENT_FEATURE_DETAIL.DocumentPlus || s?.permanentFeatureCode === PERMANENT_FEATURE_DETAIL.DocumentPlus2) &&
    //         (s?.isSubscriptionFeature === true || s?.isSubscriptionFeature === 1 || String(s?.isSubscriptionFeature).toLowerCase() === 'true')
    //       );
    //       const isAiAssistenceEnable = Array.isArray(subscriptionData) && subscriptionData.some((s: any) =>
    //         Number((s?.permanentFeatureCode) === PERMANENT_FEATURE_DETAIL.AiAssistenceEnable) &&
    //         (s?.isSubscriptionFeature === true || s?.isSubscriptionFeature === 1 || String(s?.isSubscriptionFeature).toLowerCase() === 'true')
    //       );
    //       obj['isAiAssistenceEnable'] = isAiAssistenceEnable;
    //       const hasNormalSubscription = Array.isArray(subscriptionData) && subscriptionData.some((s: any) =>
    //         Number(s?.permanentFeatureCode) === PERMANENT_FEATURE_DETAIL.DOCUMENT &&
    //         (s?.isSubscriptionFeature === true || s?.isSubscriptionFeature === 1 || String(s?.isSubscriptionFeature).toLowerCase() === 'true')
    //       );

    //       if ((!hasFormWizSubscription && !hasNormalSubscription)) {
    //         this.communicate.isLoaderLoad.next(false);
    //         localStorage.clear();
    //         this.showNoSubscriptionModal();
    //       } else {
    //         if (hasFormWizSubscription) {
    //           obj['hasNormalSubscription'] = true;
    //           obj['hasFormWizSubscription'] = true;
    //         } else {
    //           obj['hasFormWizSubscription'] = false;
    //           obj['hasNormalSubscription'] = hasNormalSubscription;
    //         }
    //         obj['isBusinessAccount'] = true;
    //         obj['isPersonalAccount'] = false;
    //         this.communicate.isLoaderLoad.next(false);
    //         localStorage.setItem('sp-user', JSON.stringify(obj));
    //         this.toastr.success('Logged in successfully', '');
    //         this.loginForm.reset();
    //         //this.router.navigate(['/documents']);
    //         this.router.navigate(['/advance']);
    //       }


    //     }
    //     else {
    //       this.toastr.error(res.message || res.error, '');
    //     }
    //   },
    //   error: (err) => {
    //     this.communicate.isLoaderLoad.next(false);
    //     this.toastr.error(err['message'], '');
    //   },
    // });

    if (this.isSuperAdmin) {
      

      // ADMIN LOGIN
      this.api.allPostMethodLogin('Authentication/Salogin', payload).subscribe({
        next: async (res: any) => {
          this.communicate.isLoaderLoad.next(false);

          if (res['error'] != true) {
            localStorage.setItem('sp-token', res['data']['token']);
            localStorage.setItem('userId', res['data']['userId']);
            localStorage.setItem('userName', res['data']['fullName']);
            localStorage.setItem('permission_data', JSON.stringify(res['data']['permissionData']));
            const senderTabId = this.getTabId();
            localStorage.setItem(
              'GLOBAL_LOGIN',
              JSON.stringify({
                senderTabId,
                time: Date.now()
              })
            );

            let obj = JSON.parse(JSON.stringify(res['data']));
            obj['permissionData'] = null;

            // ADMIN PERMISSION
            obj['isAiAssistenceEnable'] = true;
            obj['hasNormalSubscription'] = true;
            obj['hasFormWizSubscription'] = true;

            obj['isBusinessAccount'] = true;
            obj['isPersonalAccount'] = false;

            this.communicate.isLoaderLoad.next(false);
            localStorage.setItem('sp-user', JSON.stringify(obj));

            this.toastr.success('Logged in successfully', '');
            this.loginForm.reset();
            this.router.navigate(['/advance']);
          }
          else {
            this.toastr.error(res.message || res.error, '');
          }
        },
        error: (err) => {
          this.communicate.isLoaderLoad.next(false);
          this.toastr.error(err['message'], '');
        },
      });

    } else {

      //USER LOGIN
      this.api.allPostMethod('authentication/login', payload).subscribe({
        next: async (res: any) => {
          this.communicate.isLoaderLoad.next(false);

          if (res['error'] != true) {
            localStorage.setItem('sp-token', res['data']['token']);
            localStorage.setItem('userId', res['data']['userId']);
            localStorage.setItem('userName', res['data']['fullName']);
            localStorage.setItem('permission_data', JSON.stringify(res['data']['permissionData']));
            const senderTabId = this.getTabId();
            localStorage.setItem(
              'GLOBAL_LOGIN',
              JSON.stringify({
                senderTabId,
                time: Date.now()
              })
            );
            this.notifyIfPermissionsMissing(res['data']?.['permissionData'], 'authentication/login');

            let obj = JSON.parse(JSON.stringify(res['data']));
            obj['permissionData'] = null;

            const subscriptionData: any = await this.getAllSubscriptionFeatures();

            const hasFormWizSubscription = Array.isArray(subscriptionData) && subscriptionData.some((s: any) =>
              Number((s?.permanentFeatureCode) === PERMANENT_FEATURE_DETAIL.DocumentPlus || s?.permanentFeatureCode === PERMANENT_FEATURE_DETAIL.DocumentPlus2) &&
              (s?.isSubscriptionFeature === true || s?.isSubscriptionFeature === 1 || String(s?.isSubscriptionFeature).toLowerCase() === 'true')
            );

            const isAiAssistenceEnable = Array.isArray(subscriptionData) && subscriptionData.some((s: any) =>
              Number((s?.permanentFeatureCode) === PERMANENT_FEATURE_DETAIL.AiAssistenceEnable) &&
              (s?.isSubscriptionFeature === true || s?.isSubscriptionFeature === 1 || String(s?.isSubscriptionFeature).toLowerCase() === 'true')
            );

            obj['isAiAssistenceEnable'] = isAiAssistenceEnable;

            const hasNormalSubscription = Array.isArray(subscriptionData) && subscriptionData.some((s: any) =>
              Number(s?.permanentFeatureCode) === PERMANENT_FEATURE_DETAIL.DOCUMENT &&
              (s?.isSubscriptionFeature === true || s?.isSubscriptionFeature === 1 || String(s?.isSubscriptionFeature).toLowerCase() === 'true')
            );

            if ((!hasFormWizSubscription && !hasNormalSubscription)) {
              this.communicate.isLoaderLoad.next(false);
              localStorage.clear();
              this.showNoSubscriptionModal();
            } else {
              if (hasFormWizSubscription) {
                obj['hasNormalSubscription'] = true;
                obj['hasFormWizSubscription'] = true;
              } else {
                obj['hasFormWizSubscription'] = false;
                obj['hasNormalSubscription'] = hasNormalSubscription;
              }

              obj['isBusinessAccount'] = true;
              obj['isPersonalAccount'] = false;

              this.communicate.isLoaderLoad.next(false);
              localStorage.setItem('sp-user', JSON.stringify(obj));

              this.toastr.success('Logged in successfully', '');
              this.loginForm.reset();
              this.router.navigate(['/advance']);
            }


          }
          else {
            this.toastr.error(res.message || res.error, '');
          }
        },
        error: (err) => {
          this.communicate.isLoaderLoad.next(false);
          this.toastr.error(err['message'], '');
        },
      });

    }

  }


  async getAllSubscriptionFeatures() {
    return new Promise((resolve, rej) => {
      this.api.allPostMethod('SubscriptionCheck/GetAll', {}).subscribe({
        next: (res: any) => {
          if (res['error'] != true) {
            resolve(res['data']);
          } else {
            resolve([])
            this.toastr.error(res.message || res.error, '');
          }
        },
        error: (err) => {
          resolve([])
          this.toastr.error(err['message'], '');
        },
      });

    })

  }


  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }


  // ADD: show modal that user does not have valid subscription
  private showNoSubscriptionModal() {
    const modalRef = this.modalService.open(InfoModalComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
    // You can add i18n key if needed: this.translate.instant('SUBSCRIPTION.INVALID')
    modalRef.componentInstance.message =
      'You do not have a valid subscription to access this feature. Please upgrade your plan.';
    modalRef.result.finally(() => {
      // Optional redirect after closing modal
      window.location.href = environment.blazzerUrl;
    });
  }

  getTabId(): string {
     let tabId = sessionStorage.getItem('TAB_ID');
     if (!tabId) {
       tabId = uuidv4();
       sessionStorage.setItem('TAB_ID', tabId);
     }
     return tabId;
  }

  private notifyIfPermissionsMissing(permissionData: any, source: string): void {
    if (this.isSuperAdmin) {
      return;
    }
    if (!Array.isArray(permissionData)) {
      this.adminNotify.notifyMissingPermissions(`${source} returned no permissionData`);
      return;
    }
    if (permissionData.length === 0) {
      this.adminNotify.notifyMissingPermissions(`${source} returned an empty permission list`);
    }
  }



}
